import { useQuery } from 'react-query';
import { useHttpClient } from '../../../../shared/http/HttpClientProvider';
import { parserNavigator } from '../../../common/utils/parserNavigator';

import { QueryOptions, QueryResult } from '../../../../shared/types/query';
import { ApiNavigator } from '../../../common/types/apiNavigator';
import { actionUrlParser, IActionUrlDataFromServer } from '../types/ActionUrl';
import { PAGE_KEY } from './index';

export function useGetActionUrls(options?: QueryOptions<ApiNavigator<IActionUrlDataFromServer>>): QueryResult<ApiNavigator<IActionUrlDataFromServer>> {
  const http = useHttpClient();

  return useQuery<ApiNavigator<IActionUrlDataFromServer>>({
    ...options,
    queryKey: [`${PAGE_KEY}/getAll`],
    queryFn: async () => {
      return http.request({
        method: 'get',
        url: 'ActionUrls',
      }).then(result => {
        return parserNavigator.fromJson(result.data, actionUrlParser.fromJson);
      })
    },
  })
}